module.exports = __webpack_public_path__ + "static/media/ic_search-gray1.fb831abb.svg";